{
  "user_invitations": {
    "navigation_title": "Invitations",
    "title": "User Invitations",
    "form_title": "User Invitation",
    "accept_form_title": "Accept User Invitation",
    "user_created": "User account was created successfully! You can login now",
    "create_new": "Invite User",
    "save": "Send Invitation",
    "go_to_index": "Back To Invitations",
    "empty_list": "No user invitations",
    "select_org": "Select Inviting Organization",
    "resend": "Resend Invitation"
  }
}
